
import {get,post,postfrom} from "@/utils/http";

export const _login = params => postfrom("/login", params); // 用户登录
export const _logout = params => get("/logout", params); // 用户登录
export const _getMenuList = params => post("/menu", params); // 获取菜单
export const _editPwd = params => post("/sysUser/updatePassword", params); // 修改密码
export const _editPersonalMsg = params => postfrom("/sysUser/updateByUserId", params); // 修改个人信息
